import {
  DateInput,
  DateInputProps,
  DateInputStylesNames,
} from '@mantine/dates';
import stylesColors from 'common/styles/styles.colors';
import * as React from 'react';

import CustomFormControl, {
  CustomFormControlProps,
} from '../custom-form-control';
import { styles } from '../styles';

type CombinedProps = DateInputProps &
  Omit<
    CustomFormControlProps,
    'name' | 'overrides' | 'positive' | 'error' | 'children'
  >;
export interface MasterDatePickerProps extends CombinedProps {
  noMargin?: boolean;
  errorMessage?: string;
  overrides?: {
    [key in DateInputStylesNames]?: React.CSSProperties;
  };
}

export default function MasterDatePicker(props: MasterDatePickerProps) {
  const {
    minDate = new Date('1900-01-01T17:00:00.000Z'),
    required,
    hideLabel,
    label = '',
    hideRequiredStar,
    valueFormat = 'DD/MM/YYYY',
    clearable = true,
    noMargin,
    errorMessage,
    firstDayOfWeek = 0,
    overrides,
    ...restProps
  } = props;

  return (
    <CustomFormControl
      required={required}
      hideLabel={hideLabel}
      label={label}
      hideRequiredStar={hideRequiredStar}
      error={errorMessage}
      disabled={restProps.disabled}
      noMargin={noMargin}
    >
      <DateInput
        {...restProps}
        valueFormat={valueFormat}
        minDate={minDate}
        firstDayOfWeek={firstDayOfWeek}
        size="xs"
        styles={{
          input: {
            borderRadius: 8,
            fontSize: 16,
            ':disabled': {
              ...styles.reset,
              opacity: 1,
              color: stylesColors.inkDark,
            },
            ...overrides?.input,
          },
          ...overrides,
        }}
        clearable={clearable}
        placeholder={props.placeholder ?? 'DD/MM/YYYY'}
      />
    </CustomFormControl>
  );
}
